import { Box } from "@mui/material";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import { FilterOption } from "../Configs/ConfigsFilterItems";

const SELECTED_COLOR = "#9C27B0";
const UNSELECTED_COLOR = "#000000DE";

interface Props {
  interfaceOptions: FilterOption[];
  selectedInterfaces: string[];
  onSelectedInterfacesChange: (value: string[]) => void;
  onClearFilters: () => void;
}

/**
 * The Reports filter set. The interface filter is id-valued, so it is passed as
 * explicit `options` (label/value pairs) rather than derived from the rows.
 *
 * FilterComponent owns the `reportFilters` query param and resets `page` when a
 * selection changes; it also renders the Clear Filter button.
 */
const ReportsFilterItems = ({
  interfaceOptions,
  selectedInterfaces,
  onSelectedInterfacesChange,
  onClearFilters,
}: Props) => {
  const filterConfig = [
    {
      key: "iface",
      name: "Interface",
      label: "Select an Interface",
      selectedOption: selectedInterfaces,
      filterName: "iface",
      options: interfaceOptions,
      onSelectionChange: onSelectedInterfacesChange,
      count: selectedInterfaces.length,
      colorSelected:
        selectedInterfaces.length > 0 ? SELECTED_COLOR : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: true,
    },
  ];

  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={onClearFilters}
        filterNameURL="reportFilters"
      />
    </Box>
  );
};

export default ReportsFilterItems;
